import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../../api/supabase"; // Ensure this path is correct
import PropTypes from "prop-types"; // Import PropTypes

const NavigateAuth = ({ children }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession(); // Correct method to get session
      if (!session) {
        // If the user is not logged in, redirect to the login page
        navigate("/login");
      } else {
        setIsLoading(false);
      }
    };

    checkSession();
  }, [navigate]);

  if (isLoading) {
    return <div>Loading...</div>; // Optional: show a loading indicator while checking the session
  }

  // Render the protected component if the user is authenticated
  return children;
};

// Define PropTypes for the NavigateAuth component
NavigateAuth.propTypes = {
  children: PropTypes.node.isRequired, // children must be a valid React node and is required
};

export default NavigateAuth;
